const delayMilliseconds = async (duration: number = 0) => {
  await new Promise(resolve => setTimeout(resolve, duration));
};

export default delayMilliseconds;
